<script lang="ts">
  import { goto } from '@roxi/routify'
  import TopBarPage from '../Navigation/TopLevelPages/TopBarPage.svelte'
</script>

<TopBarPage>
  <div id="container">
    <h1>404!</h1>
    <p>Nothing to see here!</p>
    <p>Hit the button below to get back to the Retro.</p>
    <button on:click={$goto('/')}>To The Retro</button>
  </div>
</TopBarPage>

<style>
  #container {
    display: flex;
    flex-flow: column nowrap;
    align-items: 'center';
  }
</style>
